import React, { useEffect, useState } from 'react'
import CardCustom from '../custom/card-custom'
import { useTheme } from '@mui/material'
import ReactApexcharts from 'react-apexcharts'
import { getDashboardTurnoverAPI } from '../../services/dashboard'
import moment from 'moment'

export default function TurnoverRate() {
  const theme = useTheme()
  const [dataOut, setDataOut] = useState([])
  const [dataCome, setDataCome] = useState([])
  const [categories, setCategories] = useState([])
  useEffect(() => {
    fnGetData()
    return () => {}
  }, [])

  const fnGetData = async () => {
    try {
      const resp = await getDashboardTurnoverAPI()
      if (!resp) return
      if (resp.status) {
        setDataCome(resp.result.map((d) => d.count_come))
        setDataOut(resp.result.map((d) => d.count_out))
        setCategories(
          resp.result.map((d) => moment(d.months, 'MM').format('MMMM'))
        )
      }
    } catch (error) {}
  }

  const series = [
    {
      name: 'New Employee',
      data: dataCome
    },
    {
      name: 'Resign Employee',
      data: dataOut
    }
  ]
  const colors = ['#0d6efd', '#b5b5b5']

  const fontFamily = 'Sarabun'
  const options = {
    chart: {
      type: 'bar',
      parentHeightOffset: 0,
      toolbar: { show: false },
      offsetX: 0
    },
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 3,
        columnWidth: '40%',

        // startingShape: 'rounded',
        // endingShape: 'rounded',
        dataLabels: { position: 'top' }
      }
      // bar: {
      //   horizontal: false,
      //   columnWidth: '55%',
      //   endingShape: 'rounded'
      // },
    },
    // legend: { show: false },
    tooltip: { enabled: true },
    dataLabels: {
      offsetY: -20,
      formatter: (val) => `${val}`,
      style: {
        fontWeight: 500,
        fontSize: '13px',
        colors: [theme.palette.text.secondary]
      }
    },
    colors,
    states: {
      hover: {
        filter: { type: 'none' }
      },
      active: {
        filter: { type: 'none' }
      }
    },
    grid: {
      show: false,
      padding: {
        top: 20,
        left: -5,
        right: -8,
        bottom: -12
      }
    },
    xaxis: {
      axisTicks: { show: true },
      axisBorder: { color: theme.palette.divider },
      categories,
      labels: {
        style: {
          fontSize: '14px',
          fontFamily: fontFamily
        }
      }
    },
    yaxis: {
      labels: {
        offsetX: 1,
        formatter: (val) => `${val}`,
        style: {
          fontSize: '14px',
          colors: theme.palette.text.disabled,
          fontFamily: fontFamily
        }
      }
    },
    responsive: [
      {
        breakpoint: theme.breakpoints.values.sm,
        options: {
          plotOptions: {
            bar: { columnWidth: '20%' }
          }
        }
      }
    ]
  }

  return (
    <CardCustom className="h-100" minHeight="none">
      <div className="p-3">
        <div className="mb-3">
          <h5 className="mb-0">Turnover Rate </h5>
          <span className="fw-light font-small-2 text-muted">
            Historical data (lasted 6 months)
          </span>
        </div>
        <ReactApexcharts
          type="bar"
          height={450}
          options={{ ...options }}
          series={series}
        />
      </div>
    </CardCustom>
  )
}
